import moment from 'moment-timezone';

export function formatDate(str, format = 'DD/MM/YYYY HH:mm') {
    const date = moment(str);
    if (date.isValid() && format) {
        return date.format(format);
    }

    return null;
}

export function convertToMoment(val) {
    return !val || moment.isMoment(val)
        ? val
        : moment(val);
}

/**
 * Converte o valor de um filtro do tipo "daterange" no intervalo do dia (início/fim).
 *
 * Os filtros das listagens são persistidos na query string e no localStorage via JSON, então ao
 * voltar para a página as datas são restauradas como texto (ISO) em vez de moment. Sem a conversão
 * o filtro quebra a requisição e a listagem volta vazia.
 *
 * @param {Array} value valor do filtro, com datas em moment ou texto
 * @returns {{ start: object|null, end: object|null }}
 */
export function getDayRange(value) {
    if (!value?.length) {
        return { start: null, end: null };
    }

    const [start, end] = value.map(convertToMoment);

    return {
        start: start?.isValid() ? start.clone().startOf('day') : null,
        end: end?.isValid() ? end.clone().endOf('day') : null,
    };
}

/**
 * Validade padrão de um grupo: fim do dia local, `defaultDaysToExpire - 1` dias à frente (nunca
 * antes de hoje) — o mesmo cálculo que o backend faz quando o check-in chega sem data. Grupo sem
 * padrão: sem validade.
 *
 * @param {number|null} defaultDaysToExpire
 * @returns {object|null} moment
 */
export function defaultExpirationDate(defaultDaysToExpire) {
    return defaultDaysToExpire
        ? moment().add(Math.max(defaultDaysToExpire - 1, 0), 'days').endOf('day')
        : null;
}

/**
 * Serializa o "Válido até" para o backend como hora de parede, sem offset (AD-016).
 *
 * A coluna é `timestamp without time zone` e o Core compara o valor com o próprio relógio. Sem
 * offset, o backend grava exatamente a hora que a pessoa viu na tela, e o padrão calculado aqui
 * fica idêntico ao que o backend grava sozinho (`DateTime.Today 23:59:59`), qualquer que seja o
 * fuso do container. Com offset, um container em UTC gravaria 3h a mais.
 *
 * @param {object|string|null} value moment escolhido em tela, ou texto vindo do backend
 * @returns {string|null}
 */
export function serializeExpirationDate(value) {
    return value ? moment(value).format('YYYY-MM-DDTHH:mm:ss') : null;
}
